package com.wintermar.inspection.util.middleware

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.wintermar.inspection.core.ui.component.connectivity_monitor.util.ConnectivityMonitor
import com.wintermar.inspection.core.ui.component.connectivity_monitor.util.ConnectivityMonitorStatus
import com.wintermar.inspection.navigation.NavigationController
import com.wintermar.inspection.navigation.Route
import kotlinx.browser.window
import org.koin.compose.koinInject

/**
 * JS-specific platform middleware that monitors internet connectivity.
 * - When connection is lost: redirects to NotFound screen
 * - When connection is restored: refreshes the browser
 */
@Composable
actual fun PlatformMiddleware(
    navigationController: NavigationController?,
    content: @Composable () -> Unit
) {
    val connectivityMonitor: ConnectivityMonitor = koinInject()
    val connectivityStatus by connectivityMonitor.status.collectAsState()
    var previousStatus by remember { mutableStateOf<ConnectivityMonitorStatus?>(null) }

    // Initialize connectivity monitoring when the middleware is first composed
    LaunchedEffect(connectivityMonitor) {
        connectivityMonitor.start()
        return@LaunchedEffect
    }

    // Handle connectivity status changes
    LaunchedEffect(connectivityStatus) {
        when (connectivityStatus) {
            ConnectivityMonitorStatus.DISCONNECTED -> {
                // Navigate to NotFound when disconnected
                navigationController?.navigateTo(Route.NotFound, removeAllExistingRoute = true)
            }
            ConnectivityMonitorStatus.CONNECTED -> {
                // Refresh page when reconnected from disconnected state
                if (previousStatus == ConnectivityMonitorStatus.DISCONNECTED) {
                    window.location.reload()
                }
            }
            ConnectivityMonitorStatus.UNKNOWN -> {
                // No action needed for unknown status
            }
        }
        previousStatus = connectivityStatus
    }

    // Render content
    content()
}
